import { render } from "./Billing_settlement.vue?vue&type=template&id=1d50c106&scoped=true"
import script from "./Billing_settlement.vue?vue&type=script&lang=js"
export * from "./Billing_settlement.vue?vue&type=script&lang=js"

import "./Billing_settlement.vue?vue&type=style&index=0&id=1d50c106&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d50c106"]])

export default __exports__